import "./CartografiaMedia.css";
import { assetUrl } from "../../wordpress";

const collaborators = [
	["APAT-CADAQUES.svg", "APAT Cadaqués"],
	["CAP-DE-CREUS-BAR.svg", "Cap de Creus Bar"],
	["CAP-DE-CREUS.svg", "Cap de Creus"],
	["CARPE-DIEM.svg", "Carpe Diem"],
	["CHARTER-SANT.svg", "Charter Sant"],
	["LA-SAL-CADAQUES.svg", "La Sal Cadaqués"],
	["ONA.svg", "Ona"],
	["SOCIETAT.svg", "Societat"],
	["SOLIXENT.svg", "Sol Ixent"],
] as const;

const collaboratorsPath = "/assets/cartografia/colaborators_infinit_carousel";

export function CartografiaPromo() {
	return (
		<div className="cartografia-promo">
			<img
				src={assetUrl("/assets/cartografia/POST_4x5_PROMO_01.png")}
				alt="Presentació de Cartografia de l’estrany del 21 de març"
			/>
			<img
				src={assetUrl("/assets/cartografia/POST_4x5_PROMO_02.png")}
				alt="Presentació de Cartografia de l’estrany del 28 de març"
			/>
		</div>
	);
}

export function CollaboratorsCarousel() {
	return (
		<section className="collaborators" aria-labelledby="collaborators-title">
			<h2 id="collaborators-title">Col·laboradors</h2>
			<div className="collaborators__viewport">
				<div className="collaborators__track">
					<LogoSet />
					<div className="collaborators__set" aria-hidden="true">
						{collaborators.map(([file, label]) => (
							<img
								key={file}
								src={assetUrl(`${collaboratorsPath}/${file}`)}
								alt={label}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}

function LogoSet() {
	return (
		<div className="collaborators__set">
			{collaborators.map(([file, label]) => (
				<img key={file} src={assetUrl(`${collaboratorsPath}/${file}`)} alt={label} />
			))}
		</div>
	);
}
